import React from 'react';
import axios from 'axios';
import Authentication from '../helpers/Authentication'
import RatingTableSeacherLauncher from '../components/ratingTables/RatingTableSeacherLauncher';
import CertificatePartA from '../components/certificates/storageManagementValidation/CertificatePartA';
import FPHAuthorityHolderDetailsFormSection from '../components/certificates/common/FPHAuthorityHolderDetailsFormSection';

import Audit from '../components/certificates/storageManagementValidation/Audit';
import CertificatePartC from '../components/certificates/storageManagementValidation/CertificatePartC';
import CertificatePartD from '../components/certificates/storageManagementValidation/CertificatePartD';
import CertificatePartE from '../components/certificates/storageManagementValidation/CertificatePartE';
import CertificateConfirmation from '../components/certificates/storageManagementValidation/CertificateConfirmation'
import {uploadOptionsForStoreManagementValidation as uploadOptions} from '../constants/MeterFormConstants'

import DisplayForRoles from '../components/tools/DisplayForRoles'
import CertificateFiles from '../components/certificates/common/CertificateFiles'
import CertificateAdmin from '../components/certificates/common/CertificateAdmin'
import { formValueSelector, reduxForm, change } from 'redux-form'
import { connect } from 'react-redux'
import { load, save, findById } from '../components/certificates/storageManagementValidation/Reducers';
import { deleteDraftFormGeneric} from '../components/certificates/common/MeterCertificateCommon'
import {PrivacyStatementFPH, GlossaryFPH} from '../components/common/StaticContents';
import {StepProgressBar} from '../components/tools/BootstrapControls'
import uiHelpers from '../helpers/uiHelpers';

const authentication = new Authentication();

const ID = 'id';
export default class StorageManagementValidationCertificate extends React.Component {

  approvedWorkDetails = {};
  authorityHolderDetails = {}; 
  floodplainWorkDetails = {};
  #currentUserEmail;
  #currentUserId;

  ajaxConfig = {
    baseURL: process.env.REACT_APP_WEBAPI_URL,
    headers: { 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authentication.getToken() }
  };

  constructor(props) {
    super(props)
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.#currentUserEmail = authentication.currentUser().emails;
    this.state = {
      page: -1,        
      data: {},
      confirmingSubmission : false,
      tab : 'MAIN'
    }
  }
  

  async componentDidMount() {   
    const currentContxt = this;
    axios.post('users/getprofile', JSON.stringify({ email: this.#currentUserEmail }), this.ajaxConfig).then(response => {
      currentContxt.#currentUserId = response.data.data.user.user.id;
      currentContxt.pageRefresh();
      
    }).catch(function (error) {
      console.log(error);
      uiHelpers.showErrorTop('Error occurred when reading your user info');
    });
  }

  pageRefresh = async(id) =>{
    var certificateID = id;

    if(!id && this.props.storageManagementValidationData)
      certificateID = this.props.storageManagementValidationData.id;

    let search = window.location.search;
    let params = new URLSearchParams(search);

    if(!certificateID || certificateID==0){
      certificateID = params.get(ID);
      if(certificateID)
        certificateID = parseInt(certificateID)
    }

    if (certificateID && certificateID!=0) {
      if(this.state.page==-1)
        this.setState({ page: 0});

      try {

        uiHelpers.showProgressOnTop("Getting/Refreshing certificate data...");
        this.props.dispatch(change(this.props.form, 'loading', true));
        await this.props.dispatch(findById(certificateID));  
        uiHelpers.hideProgressOnTop();
        this.props.dispatch(change(this.props.form, 'loading', false));

      } catch (error) {
        console.log(error)
        uiHelpers.showErrorTop("Error when getting data...", true, false);
      }

    } else {
      try {
        uiHelpers.showProgressOnTop("Loading data...");
        this.props.dispatch(change(this.props.form, 'loading', true));
        await this.props.dispatch(load());
        uiHelpers.hideProgressOnTop();
        this.props.dispatch(change(this.props.form, 'loading', false));  
      } catch (error) {
        uiHelpers.showErrorTop("Error when getting data...", true, false);
      }

    }
  }

  nextPage = (values) => {
    this.saveDraft(values);
  }

  completeConfirmation = () => {
    this.setState({ confirmingSubmission: false, page: this.state.page + 1 });
  }

  cancelConfrimSubmission = () => {
    this.setState({ confirmingSubmission: false });
  }

  cancelConfrimSubmissionAndGoToPage = (page) => {
    this.setState({ confirmingSubmission: false, page: page });
  }

  saveDraft = (values) => {  
   debugger;
    
    if (parseInt(values.clickSaveDraft) === 1 && parseInt(values.clickNext) === 0) {     
      try {
        uiHelpers.showProgressOnTop("Saving your record...");
        this.props.dispatch(change(this.props.form, 'loading', true));      
        this.props.dispatch(save(values, this.pageRefresh));
        
      }  catch (error) {
        uiHelpers.showErrorTop("Error when saving your record..", true, false);
      }

    } else if (parseInt(values.clickSaveDraft) === 0 && parseInt(values.clickNext) === 1 && values.storageManagementValidationData.formStatus == 2 ) {
      uiHelpers.showProgressOnTop("Saving your record...");
      this.props.dispatch(change(this.props.form, 'loading', true));  
      this.props.dispatch(save(values, this.pageRefresh));
    } else {
      if(this.state.page == 2 && !this.state.confirmingSubmission ) {//if page 4 and write-mode and not confirmed yet
        this.setState({ confirmingSubmission: true }); //show confirm
      } else if(this.state.page == 2 && this.state.confirmingSubmission ) { //if previously confirmed , goto next page
        this.setState({ confirmingSubmission: false, page: this.state.page + 1 });
      }else {
        this.setState({ page: this.state.page + 1 });
      }
    }
      console.log(JSON.stringify("end_of_saveDraft"));
    
  }

  ratingTableSelectedHandler = (selectedRatingTable) => {    
    this.props.floodplainWorkDetails.ratingTable = selectedRatingTable;
    debugger;
    this.setState({ page: this.state.page + 1 });
  }

  previousPage = () => {
    debugger;
    if(this.state.page == 3) {      
      this.setState({ confirmingSubmission: true, page: this.state.page - 1 });
    } else  {
      this.setState({ page: this.state.page - 1 });  
    }         
  }

  HideShow = () => {
    this.setState({ showInstructions: !this.state.showInstructions });
  }

  deleteDraft = ()=>{
    if (this.props.storageManagementValidationData.id != 0) {
    let currentContext = this;
    let url = '/storageManagementValidation/deleteDraft?cid='+this.props.storageManagementValidationData.id;
      deleteDraftFormGeneric(
        parseInt(this.props.storageManagementValidationData.id)
        , function(){
          currentContext.props.dispatch(change(currentContext.props.form, 'loading', true));
        }
        , function(){
          window.location = 'Home';
        }
        , function() {

        }, url
      );
    }
  }

  render() {
    const { page, showInstructions, confirmingSubmission } = this.state

    const { form , loading} = this.props

    return (<>
      <h3  className='mb-3'>Primary Measurement Device Validation</h3>

      <p>
        <a className="btn btn-primary" onClick={this.HideShow}>Privacy and Glossary</a>
      </p>
      {showInstructions && (<div class="card card-body fs-90 mb-5">
        <h5 className='mb-3'>Privacy Statement</h5>
        {PrivacyStatementFPH}
        <h5>Glossary of terms</h5>
        {GlossaryFPH}
      </div>)}
     
      {!confirmingSubmission && page === -1 && <RatingTableSeacherLauncher onRatingTableSelected = {this.ratingTableSelectedHandler} />}


      {page >= 0 && <>
        <div class="card mb-5">
          <div class="card-body row">
              <div className='col-md-3'>
                <label class="form-label">Record ID</label>
                <input type="text" disabled={true} class="form-control" value={this.props.storageManagementValidationData.id == 0 ? "Not saved" : this.props.storageManagementValidationData.id} />
              </div>
              <div className='col-md-3'>
                <label class="form-label">Form Status</label>
                <input type="text" disabled={true} class="form-control" value={this.props.storageManagementValidationData.formStatus==1?'Draft' : 'Submitted'} />
              </div>
              <div className='col-md-3'>
                <label class="form-label">DQP</label>
                <input type="text" disabled={true} class="form-control" value={this.props.storageManagementValidationData.createdBy ? (this.props.storageManagementValidationData.createdBy.firstName + " " + this.props.storageManagementValidationData.createdBy.lastName) : ""} />
              </div>
          </div>
        </div>
      
        <ul class="nav nav-tabs mb-3">
            <li class="nav-item ">
              <a class={`nav-link ${this.state.tab == 'MAIN'?'active':''}`} aria-current="page" href="#"
                  onClick={(e)=>{e.preventDefault(); this.setState({ tab : 'MAIN'}); }}
              >Record details</a>
            </li>
            <li class="nav-item">
              <a class={`nav-link ${this.state.tab == 'AUDIT'?'active':''}`} href="#"
                  onClick={(e)=>{e.preventDefault(); this.setState({ tab : 'AUDIT'}); }}
              >Audit/Logs</a>
            </li>
            {this.props.storageManagementValidationData.formStatus == 2 && <DisplayForRoles roles={{superAdmin : true, isCFOAdmin:true}}>
              <li class="nav-item">
                  <a class={`nav-link ${this.state.tab == 'FILES'?'active':''}`} href="#"
                    onClick={(e)=>{e.preventDefault(); this.setState({ tab : 'FILES'}); }}
                  >Files</a>
              </li>
            </DisplayForRoles>}
            {this.props.storageManagementValidationData.formStatus == 2 && <DisplayForRoles roles={{superAdmin : true}}>
              <li class="nav-item">
                  <a class={`nav-link ${this.state.tab == 'ADMIN'?'active':''}`} href="#"
                    onClick={(e)=>{e.preventDefault(); this.setState({ tab : 'ADMIN'}); }}
                  >Admin</a>
              </li>
            </DisplayForRoles>}
        </ul>
        

        {this.state.tab == 'AUDIT' && <Audit id={this.props.storageManagementValidationData.id} /> }


        {this.state.tab == 'ADMIN' && this.props.storageManagementValidationData.formStatus == 2 && <DisplayForRoles roles={{superAdmin : true, isCFOAdmin:true}}>
          <CertificateAdmin id={this.props.storageManagementValidationData.id} entityType="StorageManagementValidation" />
        </DisplayForRoles> }

        {this.state.tab == 'FILES' && <DisplayForRoles roles={{superAdmin : true, isCFOAdmin:true}}>
            <CertificateFiles 
              form={form} 
              certificateNameForSelector="storageManagementValidationData"
              fileTypeResolver={(document)=>{
                var option = uploadOptions.filter(option=>option.id==document.documentType)[0];
                return <>{option?option.name:""}</>
                
              }}
            />
        </DisplayForRoles> }

        {this.state.tab == 'MAIN' && <>
          {this.props.storageManagementValidationData.formStatus == 1 && this.props.storageManagementValidationData.createdBy && this.props.storageManagementValidationData.createdBy.id != this.#currentUserId && <div className='alert alert-primary'>
            This form is owned by <strong>{this.props.storageManagementValidationData.createdBy.firstName} {this.props.storageManagementValidationData.createdBy.lastName}</strong> and cannot be edited
          </div>}
          <div className='my-5'>      
            <StepProgressBar 
              totalSteps={6} 
              currentStep={confirmingSubmission? 4 : page>2? page+2: page+1} 
              disableFutureSteps={this.props.storageManagementValidationData.formStatus == 1} 
              stepClick={(page) =>{this.setState({page : page>=4?page-2:page-1, confirmingSubmission : page==4 })}}/>
          </div>


          {!confirmingSubmission && page === 0 && <CertificatePartA form={form} onSubmit={this.nextPage} previousPage={this.previousPage} disableEditing={this.props.storageManagementValidationData.createdBy && this.props.storageManagementValidationData.createdBy.id != this.#currentUserId}  />}
          {!confirmingSubmission && page === 1 && <FPHAuthorityHolderDetailsFormSection form={form} onSubmit={this.nextPage} previousPage={this.previousPage} disableEditing={this.props.storageManagementValidationData.createdBy && this.props.storageManagementValidationData.createdBy.id != this.#currentUserId}  />}
          {!confirmingSubmission && page === 2 && <CertificatePartC form={form} onSubmit={this.nextPage} previousPage={this.previousPage} disableEditing={this.props.storageManagementValidationData.createdBy && this.props.storageManagementValidationData.createdBy.id != this.#currentUserId}  />}

          
          {confirmingSubmission &&  
            <CertificateConfirmation 
              form={form}
              onSubmit={this.nextPage}
              completeConfirmation={this.completeConfirmation}
              cancelConfrimSubmissionAndGoToPage={this.cancelConfrimSubmissionAndGoToPage}
              cancelConfrimSubmission={this.cancelConfrimSubmission}  
              disableEditing={this.props.storageManagementValidationData.createdBy && this.props.storageManagementValidationData.createdBy.id != this.#currentUserId}
          />}       

          {!confirmingSubmission && page === 3 && <CertificatePartD form={form} onSubmit={this.nextPage} previousPage={this.previousPage} disableEditing={this.props.storageManagementValidationData.createdBy && this.props.storageManagementValidationData.createdBy.id != this.#currentUserId}  />}
          {!confirmingSubmission && page === 4 && <CertificatePartE form={form} onSubmit={this.nextPage} previousPage={this.previousPage} disableEditing={this.props.storageManagementValidationData.createdBy && this.props.storageManagementValidationData.createdBy.id != this.#currentUserId}  />}
        </>}

      </>}
          
        {/* start the delete draft dialog */}
        <div class="modal fade" id="deleteDraftModal" tabindex="-1" role="dialog" aria-labelledby="deleteDraftModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-centered" role="document">
               <div class="modal-content">
                <div class="modal-header">
                    <button type="button" id="deleteDraftModalCloseBtn"  disabled={loading} class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                  <div class="modal-body">
                    <strong>Are you sure you want to delete this draft version of the form?</strong>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" disabled={loading} data-bs-dismiss="modal">Cancel</button>
                
                    <button type="button" disabled={loading} class="btn btn-primary"
                      onClick={() => { this.deleteDraft(); }}
                    >Confirm deletion</button>
                  </div>
               </div>
            </div>
         </div>
         {/* end the delete draft dialog */}  
    </>);
  }
}


StorageManagementValidationCertificate = reduxForm({
  enableReinitialize: true,

})(StorageManagementValidationCertificate)

StorageManagementValidationCertificate = connect(
  (state, props) => ({

    initialValues: state.smvReducer,
    loaded: state.smvReducer.loaded,//doChange
    form: props.form,
    authorityHolderDetails: formValueSelector(props.form)(state, 'authorityHolderDetails'),
    floodplainWorkDetails: formValueSelector(props.form)(state, 'floodplainWorkDetails'),
    storageManagementValidationData: formValueSelector(props.form)(state, 'storageManagementValidationData'),
    loading: formValueSelector(props.form)(state, 'loading')
    // pull initial values from account reducer
  }),
  {
    load: (payload) => load(payload),
    save: (payload) => save(payload),
    findById: (id) => findById(id),   
  }
)(StorageManagementValidationCertificate)


